export const BLOCKS = [
  {
    key: 'professions',
    title: 'Профессии',
    description:
      'Эти профессии помогут получить практические навыки в подходящих профессиональных областях.',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'competences',
    title: 'Компетенции',
    description:
      'Эти компетенции помогут узнать больше о подходящих профессиональных сферах.',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'programs',
    title: 'Программы',
    description:
      'Это программы, которые помогут определиться с выбором профессии.',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'vacancies',
    title: 'Вакансии',
    description: 'Эти вакансии могут быть вам интересны',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'employer_partners',
    title: 'Работодатели',
    description: 'Эти работодатели могут быть вам интересны',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'contractor_partners',
    title: 'Образовательные организации',
    description: 'Эти образовательные организации могут быть вам интересны',
    method: 'getRecPrograms',
    data: null,
  },
  {
    key: 'articles',
    title: 'Рекомендованные статьи',
    description:
      'Эти интересные статьи, подобранные нашими редакторами, помогут ребенку узнать больше о подходящих ему профессиях',
    method: 'getMaterials',
    data: null,
  },
  {
    key: 'interviews',
    title: 'Рекомендованные интервью',
    description:
      'В этих интервью представители профессий рассказывают нашему сервису о своей работе',
    method: 'getMaterials',
    data: null,
  },
  // {
  //   key: 'videos',
  //   title: 'Рекомендованные видео',
  //   description:
  //     'Рекомендуем посмотреть эти видео, связанные с подходящими профессиям',
  //   method: 'getMaterials',
  //   data: null,
  // },
];



// WEBPACK FOOTER //
// ./src/pages/profile/views/career-guidance/components/smart/const.ts